module.exports = __webpack_public_path__ + "static/media/logo-flower@2x.098cc326.jpg";